export default __webpack_public_path__ + "static/media/Ambulancia.a4300930.png";